import { useState } from 'react';
import '../ForestDataMapLayerTree.css';
import { Modal, Tooltip } from 'antd';
import { Button, Spinner } from 'react-bootstrap';
import { getMainAttributes } from '../utils';
import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Fill, Stroke, Style, Text } from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import Sparcal from '../../lib/Sparcal';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import { get as getProjection } from 'ol/proj';

const MAX_FILE_SIZE_MB_GEOJSON = 50;
const MAX_FILE_SIZE_MB_ZIP = 10;
const MAX_FILE_SIZE_BYTES = 1024 * 1024;

const ForestDataMapAddLayer = (props) => {
  const [display, setDisplay] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  const [sizeInvalid, setSizeInvalid] = useState(false);
  const [name, setName] = useState();
  const [geoData, setGeoData] = useState(null);
  const [loading, setLoading] = useState(false);

  let rootStyle = props.style;
  if (rootStyle === undefined) {
    rootStyle = {
      width: '100%',
    };
  }

  // const isValidGeoJSON = (obj) => {
  //   if (!obj || typeof obj !== 'object') return false;

  //   const geoTypes = [
  //     'FeatureCollection',
  //     'Feature',
  //     'Point',
  //     'LineString',
  //     'Polygon',
  //     'MultiPoint',
  //     'MultiLineString',
  //     'MultiPolygon',
  //     'GeometryCollection',
  //   ];

  //   if (!obj.type || !geoTypes.includes(obj.type)) return false;

  //   if (obj.type === 'FeatureCollection') {
  //     return Array.isArray(obj.features);
  //   }

  //   if (obj.type === 'Feature') {
  //     return (
  //       obj.geometry &&
  //       typeof obj.geometry === 'object' &&
  //       geoTypes.includes(obj.geometry.type)
  //     );
  //   }

  //   // Handle raw geometry objects
  //   return obj.coordinates !== undefined;
  // };

  // useEffect(() => {
  //   if (!file) setValid(null);
  //   else {
  //     const valid = isValidGeoJSON(file);
  //     setValid(isValidGeoJSON(file));
  //   }
  // }, [file]);

  const handleImport = () => {
    const { geojson, name } = geoData;
    proj4.defs(
      'EPSG:3310',
      '+proj=aea +lat_0=0 +lon_0=-120 +lat_1=34 +lat_2=40.5 +x_0=0 +y_0=-4000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs'
    );

    register(proj4);

    const projection = getProjection('EPSG:3310');
    const features = new GeoJSON().readFeatures(geojson, {
      featureProjection: projection,
    });
    const mainAttrs = getMainAttributes(features);
    const vectorSource = new VectorSource({
      features,
    });
    var vectorLayer = new VectorLayer({
      source: vectorSource,
      zIndex: 100,
      opacity: 1,
      style: (feature) => {
        return new Style({
          stroke: new Stroke({
            color: '#1A7CFA', //'#088FFA',
            width: 1,
          }),
          fill: new Fill({
            color: 'rgba(211, 211, 211, 0.1)',
          }),
          text: new Text({
            font: '12px Calibri,sans-serif',
            fill: new Fill({
              color: '#000',
            }),
            // text: feature.get('name') ? feature.get('name') : feature.get('NAME'),
            text: mainAttrs.length === 1 ? feature.get(mainAttrs[0]) : '',
            stroke: new Stroke({
              color: '#fff',
              width: 3,
            }),
          }),
        });
      },
    });
    vectorLayer.set('name', name);
    if (geojson.crs) {
      const epsgCode = geojson.crs.properties.name;
      const parts = epsgCode.split('::');
      const code = parts[1];
      vectorLayer.set('crs', code);
    }

    props.map.addLayer(vectorLayer);
    props.map
      .getView()
      .fit(vectorSource.getExtent(), { padding: [50, 50, 50, 50] });
    props.addLayerByUser(vectorLayer);
    handleClose();
  };

  const handleFilePick = async () => {
    setSizeInvalid(false);
    setGeoData(null);
    setName(null);
    setErrorMsg(null);
    try {
      // Open the file picker
      await window
        .showOpenFilePicker({
          types: [
            {
              description: 'ZIP or GeoJSON files',
              accept: {
                'application/zip': ['.zip'],
                'application/geo+json': ['.geojson'],
                'application/json': ['.geojson'],
              },
            },
          ],
          multiple: false,
        })
        .then(async ([rawFile]) => {
          const file = await rawFile.getFile();
          const fileName = file.name.toLowerCase();
          if (fileName.endsWith('.zip')) {
            setLoading(true);
            const formData = new FormData();
            formData.append('file', file); // 'file' is the key expected by the server
            if (file.size > MAX_FILE_SIZE_MB_ZIP * MAX_FILE_SIZE_BYTES) {
              setErrorMsg('Shapefile Zip it too large');
              setSizeInvalid(true);
              setLoading(false);
              return;
            }
            await Sparcal.shapefileToGeojson(formData).then((response) => {
              setLoading(false);
              if (response.status === 200) {
                setGeoData({ geojson: response.data, name: file.name });
                setName(file.name);
              } else {
                setErrorMsg(response.response?.data?.detail + fileName);
              }
            });
          } else if (fileName.endsWith('.geojson')) {
            if (file.size > MAX_FILE_SIZE_MB_GEOJSON * MAX_FILE_SIZE_BYTES) {
              setErrorMsg('Geojson file it too large');
              setSizeInvalid(true);
              return;
            }
            const text = await file.text();
            const geojson = JSON.parse(text);
            setName(file.name);
            setGeoData({ geojson: geojson, name: file.name });
          }
        });
    } catch (err) {
      if (err.name === 'AbortError') {
        console.log('File selection aborted');
      } else {
        console.error('Error picking file:', err);
      }
    }
  };
  const handleClose = () => {
    setDisplay(false);
    setName(null);
    setGeoData(null);
  };
  return (
    <div style={{ width: '100%' }}>
      <div style={{ rootStyle, width: '100%' }}>
        <Button
          className="upload-boundary-btn"
          onClick={() => setDisplay(true)}
        >
          <strong>+ Upload Custom Boundary</strong>
        </Button>
      </div>

      <div>
        <Modal
          forceRender
          title={
            <>
              <strong>Upload a Custom Boundary</strong> - Select a Geojson file
              or Shapefile Zip to import.{' '}
            </>
          }
          open={display}
          onCancel={handleClose}
          destroyOnHidden={true}
          footer={
            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-between',
              }}
            >
              <p
                style={
                  sizeInvalid
                    ? {
                        margin: '0px 10px 0px 0px',
                        color: 'red',
                        fontWeight: 'bold',
                      }
                    : { margin: '0px 10px 0px 0px', fontSize: '12px' }
                }
              >
                <>GeoJson files must be 50 MB or smaller, </>
                <>Shapefile Zips must be 10MB or smaller</>
              </p>
              <div>
                <Button
                  onClick={() => {
                    // Temporary work around for the toggling of user added layers
                    handleImport();
                    handleImport();
                  }}
                  disabled={!geoData}
                  className="btn_primary"
                >
                  Import
                </Button>
                <Button
                  onClick={() => {
                    setDisplay(false);
                  }}
                  style={{
                    marginRight: '4px',
                    border: 'none',
                  }}
                  variant="secondary"
                >
                  Cancel
                </Button>
              </div>
            </div>
          }
          width={800}
        >
          <div>
            <Button
              style={{
                //   backgroundColor: '#61633f',
                marginRight: '4px',
                border: 'none',
                padding: '0 4px',
                borderRadius: '2px',
              }}
              variant="secondary"
              onClick={handleFilePick}
            >
              Browse...
            </Button>
          </div>
          <div
            style={{
              width: '100%',
              display: 'flex',
              // alignItems: 'center',
              // justifyContent: 'space-between',
              flexDirection: 'column',
            }}
          >
            {name ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <strong>{name}</strong>
                <Tooltip title={'Remove'} placement="right">
                  <Button
                    style={{
                      color: '#a64500',
                      textDecoration: 'none',
                      padding: '2px',
                    }}
                    size="sm"
                    variant="link"
                    onClick={() => {
                      setName(null);
                      setGeoData(null);
                    }}
                  >
                    x
                  </Button>
                </Tooltip>
              </div>
            ) : (
              <div style={{ paddingTop: '4px' }}>
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <>No file selected</>
                )}
              </div>
            )}
            {errorMsg ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <strong>{errorMsg}</strong>
                <Tooltip title={'Dismiss'} placement="right">
                  <Button
                    style={{
                      color: '#a64500',
                      textDecoration: 'none',
                      padding: '2px',
                    }}
                    size="sm"
                    variant="link"
                    onClick={() => {
                      setErrorMsg(null);
                    }}
                  >
                    x
                  </Button>
                </Tooltip>
              </div>
            ) : (
              <div style={{ height: '27px' }} />
            )}
          </div>
          {/* {valid !== null &&
            (valid ? <span>Verified</span> : <span>Invalid</span>)} */}
        </Modal>
      </div>
    </div>
  );
};
export default ForestDataMapAddLayer;
